import { ActionContext, Module } from 'vuex';
import { IAppRootState } from './IAppRootState';
import { TjipVuexAction, TjipVuexMutation } from '@tjip/vuejs';
import { appAflosschemasService, ICreateAflosschemasResponse } from '@/services/appAflosschemasService';
import * as _ from 'lodash';
import { IAflosschemadeel } from '@/model/IAflosschemadeel';
import { IAflosschemas } from '@/model/IAflosschemas';

export interface IGetAflosschemasRequest {
  hypotheeknummer: string;
  hypotheekdeelnummer: string;
  aflossingsbedrag: number;
}

export class AppAflosschemasDataModule implements Module<IAflosschemas, IAppRootState> {
  private static initialData: IAflosschemas = {
    loaded: undefined
  };

  public namespaced = true;

  public state: IAflosschemas = _.cloneDeep(AppAflosschemasDataModule.initialData);

  @TjipVuexAction
  protected init(): Promise<any> {
    // do nothing
    return Promise.resolve();
  }

  @TjipVuexAction
  private getAflosschemas(
    ctx: ActionContext<IAflosschemas, IAppRootState>,
    data: IGetAflosschemasRequest
  ): Promise<IAflosschemas> {
    return appAflosschemasService
      .createAflosschemas(data.hypotheeknummer, data.hypotheekdeelnummer, data.aflossingsbedrag)
      .then((ids: ICreateAflosschemasResponse) => {
        return Promise.all([
          appAflosschemasService.getAflosschema(ids.keyVoorBetaling),
          appAflosschemasService.getAflosschema(ids.keyNaBetaling)
        ]);
      })
      .then((data: IAflosschemadeel[][]) => {
        ctx.commit('store', {
          loaded: true,
          voorBetaling: data[0],
          naBetaling: data[1]
        });
        return ctx.state;
      });
  }

  @TjipVuexAction
  private reset(ctx: ActionContext<IAflosschemas, IAppRootState>) {
    ctx.commit('store', {});
  }

  @TjipVuexAction
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected logout(ctx: ActionContext<IAflosschemas, IAppRootState>) {
    ctx.commit('store', {});
  }

  @TjipVuexMutation
  private store(state: IAflosschemas, payload: IAflosschemas) {
    Object.assign(state, _.cloneDeep(AppAflosschemasDataModule.initialData), payload);
  }
}
